import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {getRequest} from "../../api";

export const handleLoadMuscles = createAsyncThunk('exercisePlans/handleLoadMuscles', async() => {
    try{
        const {data} = await getRequest("/info/muscles")
        return data
    }
    catch(err){
        console.log(err.response.data.message)
    }
})

const exercisePlansSlice = createSlice({
    name: 'exercisePlans',
    initialState: {
        targetMuscles: [],
    },
    reducers: {},
    extraReducers(builder){
        builder
            .addCase(handleLoadMuscles.fulfilled, (state, action) => {
                state.targetMuscles = action?.payload
            })
    }
})

export const selectTargetMuscles = state => state.exercisePlans.targetMuscles
export default exercisePlansSlice.reducer